module.exports = ".successful-text {color:green;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-users/my-details/my-details.component.css
// module id = ./src/app/manage-users/my-details/my-details.component.css
// module chunks = main